module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"referral_number_field":"Referral ID","administrative_region":"Administrative Region"},"fr":{"referral_number_field":"Referral ID","administrative_region":"Administrative Region"}}')
  delete Component.options._Ctor
}
